import styled from '@emotion/styled';

export const PackingInputContainer = styled.div`
	display: flex;
	flex-direction: column;
	position: relative;

	> .button {
		position: absolute;
		right: 1px;
		top: 1px;
		bottom: 1px;
		height: 4.25rem;
		border-radius: 3px;

		body[dir='rtl'] & {
			right: unset;
			left: 1px;
			height: 5.2rem;
		}
	}

	> input {
		padding-right: 6rem;

		body[dir='rtl'] & {
			padding-right: var(--inputPadding);
			padding-left: 6rem;
		}
	}
`;

export const ButtonContainer = styled.div`
	display: flex;
	flex-direction: row;
	gap: 1rem;

	> .button {
		background-color: var(--red-hover);
		border-color: var(--red-hover);

		&.green-button {
			background-color: var(--green-hover);
			border-color: var(--green-hover);
		}

		body[dir='rtl'] & {
			.icon {
				transform: scale(-1, 1);
			}
		}
	}
`;
